module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    class: _vm.$style.root
  }, [(_vm.autoLoginInProgress) ? _c('loading') : _c('div', {
    staticClass: "loginform col-lg-6 col-md-10"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_vm._v(_vm._s(_vm.$t('pos.login.welcome')))]), _c('p', {
    staticClass: "secondary-txt"
  }, [_vm._v(_vm._s(_vm.$t('pos.login.welcome-secondary')))]), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.tryLogin($event)
      }
    }
  }, [_c('form-input', {
    ref: "email",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t("pos.login.placeholder.email"),
      "name": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _c('form-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t("pos.login.placeholder.password"),
      "name": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": !!_vm.loginError
    }
  }, [_vm._v(_vm._s(String(_vm.loginError)))]), _c('div', [_c('b-form-checkbox', {
    model: {
      value: (_vm.rememberMe),
      callback: function($$v) {
        _vm.rememberMe = $$v
      },
      expression: "rememberMe"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.remember-me')))])], 1), _c('b-button', {
    staticClass: "btn-login",
    attrs: {
      "variant": "success",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t('pos.login.login'))))])], 1), (_vm.ssoLogin) ? _c('b-button', {
    staticClass: "btn-login",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.onSsoLogin
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t('pos.login.sso-login'))))]) : _vm._e(), (_vm.passwordResetUrl) ? _c('a', {
    staticClass: "forgotpassword",
    attrs: {
      "href": _vm.passwordResetUrl,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-test": "page-forgot-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.forgotpassword')))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3519e176"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 923
// module chunks = 1